import React from 'react'

import AdminUsersTable from './components/tables/AdminUsersTable'
export default class Users extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" className="container-xxl">
          <AdminUsersTable title={'Admin Users'} />
        </div>
      </div>
    )
  }
}
